import {Injectable} from "@angular/core";
import {Subject} from "rxjs";



@Injectable({providedIn: 'root'})
export class ProcessFlowService {

  private flowSource = new Subject<any>();
  private REFRESH = new Subject<any>();
  private Forwarded =new Subject<any>();

  flow$ = this.flowSource.asObservable();
  refresh$ = this.REFRESH.asObservable();
  forward$ = this.Forwarded.asObservable();

  public open(config:FlowConfig,onOk?:any) {
    this.flowSource.next({
      config:config,
      onOk: onOk
    });
  }

  public Refresh(boolean){
   this.REFRESH.next({
     boolean:boolean
   })
}

  public openForward(config:forwardConfig){
    this.Forwarded.next({
      config:config
    })
  }

}
export class FlowConfig {
  visible: boolean;
  darwerName: string;
  workflowId: number;
  newFlow: boolean;
  requestId: string;
  dataId: number;
  iconName:string;
  constructor(){
    this.requestId = '';
  }
}

export class forwardConfig {
    forwardId:number;
    requestId:number;
    visible: boolean;
}
